/**
 * Convierte un mapa `{ valor: etiqueta }` en opciones `{ value, label }` para un autocompletar.
 * @param {Object<string, string>} labels Etiquetas por valor.
 * @returns {Array<{value: string, label: string}>} Opciones en el orden del mapa.
 */
export const toLabelOptions = (labels) =>
  Object.entries(labels).map(([value, label]) => ({ value, label }));
